import { render, staticRenderFns } from "./DoctorateStat.vue?vue&type=template&id=66020fec&"
import script from "./DoctorateStat.vue?vue&type=script&lang=js&"
export * from "./DoctorateStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports